import {createContext, useContext, useMemo} from "react";

export const CalculatorContext = createContext({});

export const useCalculator = () => {
  const context = useContext(CalculatorContext);
  return context;
};

export const useGetTotalConfig = () => {
  const {selectedData} = useCalculator();
  const totalCPU = useMemo(() => {
    const total = selectedData.reduce((acc, curr) => {
      return acc + curr.quantity * curr.cpu;
    }, 0);
    return total;
  }, [selectedData]);

  const {ramInGB, showInGB, totalRAM} = useMemo(() => {
    const totalRAM = selectedData.reduce((acc, curr) => {
      return acc + curr.quantity * curr.ram;
    }, 0);
    return {
      ramInGB: totalRAM / 1024,
      showInGB: totalRAM >= 1024,
      totalRAM,
    };
  }, [selectedData]);

  return {ramInGB, showInGB, totalCPU, totalRAM};
};
